import { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from "react-router-dom";

import 'bootstrap/dist/css/bootstrap.css';

import { sintesoStore } from 'redux/store';

import App from './App';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import "@grapecity/ar-viewer/dist/jsViewer.min.js";
import "@grapecity/ar-viewer/dist/jsViewer.min.css";

//const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
// Re-apply the last used theme before the first render, so a reload or login
// doesn't flash classic while the user details load (Bug 14755). Saved in App.tsx.
try {
  if (localStorage.getItem("TapThemeMode") === "1") {
    document.body.classList.add("dark-mode");
  }
} catch (e) { }

const container = document.getElementById('root');
const root = createRoot(container as HTMLElement);

const AppRenderCallback = () => {
  useEffect(() => {
    console.log('App rendered successfully...');
  });

  return (<Provider store={sintesoStore}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>)
}

root.render(<AppRenderCallback />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
